import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { Wordmark } from "./Wordmark";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Simple email waitlist signup. Stores the email via /api/waitlist.
 */
export const WaitlistModal = ({ open, onOpenChange }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email)) {
      toast.error("Enter a valid email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email });
      setDone(true);
      toast.success("You are on the list.");
    } catch (err) {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenChange = (v) => {
    onOpenChange(v);
    if (!v) {
      setTimeout(() => {
        setDone(false);
        setEmail("");
      }, 250);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="mk-waitlist" data-testid="waitlist-modal">
        <DialogHeader>
          <DialogTitle className="mk-waitlist__brand">
            <Wordmark />
          </DialogTitle>
          <DialogDescription className="mk-waitlist__desc">
            {done
              ? "Thank you. We will let you know the moment mintikk is available."
              : "Join the list. Be first to know when mintikk ships."}
          </DialogDescription>
        </DialogHeader>

        {!done && (
          <form className="mk-waitlist__form" onSubmit={submit}>
            <input
              type="email"
              className="mk-waitlist__input"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              data-testid="waitlist-email-input"
            />
            <button
              type="submit"
              className="mk-waitlist__submit"
              disabled={loading}
              data-testid="waitlist-submit"
            >
              {loading ? "Joining…" : "Notify me"}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default WaitlistModal;
